/**
 * Normalized id comparisons for schedule state: API may return numeric ids while React
 * keys and optimistic creates use strings (e.g. `block-local-*`), so we compare via `String()`.
 */

/** Compare block ids across number / string. */
export function sameScheduleBlockId(a, b) {
  return a != null && b != null && String(a) === String(b);
}

/** Compare job / project ids (API may use number or string). */
export function sameScheduleProjectId(a, b) {
  return a != null && b != null && String(a) === String(b);
}
